import React, { useEffect } from 'react';

function GiftCardPurchaseForm(props) {
  const { orderId, tenderType, transactionId, transactionAmount, postUrl, requestMessage } = props.giftCardPurchaseData;

  useEffect(() => {
    postUrl && document?.giftcard?.submit();
    if (document?.giftcard) {
      localStorage.setItem('postPaymentType', 'giftCardPurchase');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document, document?.giftcard, postUrl]);

  return (
    <div>
      {postUrl && (
        <form method='POST' action={postUrl} name='giftcard'>
          <input type='hidden' name='orderId' value={orderId} />
          <input type='hidden' name='tenderType' value={tenderType} />
          <input type='hidden' name='transactionId' value={transactionId} />
          <input type='hidden' name='transactionAmount' value={transactionAmount} />
          <input type='hidden' name='msg' value={requestMessage} />
        </form>
      )}
    </div>
  );
}

export default GiftCardPurchaseForm;
